import { render, staticRenderFns } from "./WorkTemp.vue?vue&type=template&id=0ab542c8&scoped=true&"
import script from "./WorkTemp.vue?vue&type=script&lang=js&"
export * from "./WorkTemp.vue?vue&type=script&lang=js&"
import style0 from "./WorkTemp.vue?vue&type=style&index=0&id=0ab542c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab542c8",
  null
  
)

export default component.exports